import { Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { HomePageData } from 'src/actuators/home/HomePageMapping.ts';
import clsx from 'clsx';
import { memo } from 'react';
import { HomeActuator } from 'src/actuators/home/components/HomeActuator.tsx';
import { RegionsEnum } from 'src/generated/operations';

type Props = {
    homePageData: HomePageData;
    filter: Filter;
    filterConfig: FilterConfig;
    onChangeHandler: (detail: { name: string; value: string }) => void;
    currentRegion: RegionsEnum;
}

const prefixEmea = 'https://www.belimo.com/mam/europe/pictures-and-graphics/product/';
const prefixAm = 'https://www.belimo.com/mam/americas/pictures_and_graphics/products/';
const prefixAirEmea = `${prefixEmea}air_applications/Product-pictures`;
const prefixDamperAm = `${prefixAm}damper_actuators`;
const imageMapEmea = [
    ['Non fail-safe', `${prefixAirEmea}/PIC_EU_NM24A_4C-product_retina.jpg`],
    ['Fail-safe', `${prefixAirEmea}/PIC_EU_SF24A-S2_4C-product_retina.jpg`],
    [
        'Harsh environmental conditions',
        `${prefixAirEmea}/PIC_EU_IP66_NEMA4-Air_1CAB_4C-product_retina.jpg`,
    ],
    ['Fast running', `${prefixAirEmea}/PIC_EU_SMQ24A_4C-product_retina.jpg`],
    ['Linear', `${prefixAirEmea}/PIC_EU_LH24A100_4C-product_retina.jpg`],
];
const imageMapAm = [
    ['Fail-safe', `${prefixDamperAm}/AFB24_Fail-Safe_Actuator-product_retina.jpg`],
    ['Non fail-safe', `${prefixDamperAm}/AMB..-3_Non_Fail-Safe_Actuators-product_retina.jpg`],
    ['Outdoor protected', `${prefixDamperAm}/GM_GK_AF_NF_Non-s_N4-product_retina.jpg`],
    ['Quick running', `${prefixDamperAm}/NKQ_Angle-product_retina.jpg`],
    ['Linear', `${prefixDamperAm}/LHB24-SR-100-product_retina.jpg`],
];

export const ActuatorTypes = memo(({
    filterConfig,
    homePageData,
    filter,
    onChangeHandler,
    currentRegion,
}: Props) => {
    const isRadio = currentRegion !== RegionsEnum.Am;

    return (
        <aside className="vss-actuator-types">
            {filterConfig
                .map((item) => {
                    const [name] = item;
                    const { values } = homePageData[name as keyof HomePageData];
                    const imagesMap = currentRegion === RegionsEnum.Am ? imageMapAm : imageMapEmea;
                    return (
                        <div
                            key={name}
                            className={clsx({
                                'vss-actuator-types__devices': true,
                            })}
                        >
                            {imagesMap.map(([value, image]) => {
                                const actuator = values.find((it) => it.value === value);
                                if (!actuator) {
                                    return null;
                                }
                                const checked = (filter[name] || []).includes(value);
                                let disabled = false;
                                if (Array.isArray(filter[name]) && filter[name].includes('Linear') &&
                                    actuator.value !== 'Linear') {
                                    disabled = true;
                                }
                                if (Array.isArray(filter[name]) && filter[name].length > 0 &&
                                    !filter[name].includes('Linear') &&
                                    actuator.value === 'Linear') {
                                    disabled = true;
                                }

                                return (
                                    <HomeActuator
                                        disabled={currentRegion === RegionsEnum.Am ? disabled : false}
                                        key={`${name}_${actuator.value}`}
                                        imgAlt={actuator.label}
                                        imageURL={image}
                                        onChange={() => onChangeHandler({ value: actuator.value, name })}
                                        checked={checked}
                                        title={actuator.label}
                                        isRadio={isRadio}
                                    />
                                );
                            })}
                        </div>
                    );
                })}
        </aside>
    );
});
